import { render, staticRenderFns } from "./EditBlockModal.vue?vue&type=template&id=5f78412d&scoped=true&class=modalContent"
import script from "./EditBlockModal.vue?vue&type=script&lang=js"
export * from "./EditBlockModal.vue?vue&type=script&lang=js"
import style0 from "./EditBlockModal.vue?vue&type=style&index=0&id=5f78412d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f78412d",
  null
  
)

export default component.exports